module.exports = __webpack_public_path__ + "static/media/bellO.e37b6a9e.svg";